// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Ws-z","giftOrPromoSelector":"Xs-z","disabled":"Ys-z","subTitle":"Zs-z","selectShipAddressMessage":"_s-z","changePayment":"at-z"};